<template>
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Störungsmeldung erfassen</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          @click="cancel"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <h2 class="modal-title">{{ faultReportTitleProperty }}</h2>
        <h3>
          {{
            servicekleberProperty.tib.name == servicekleberProperty.data.extRef
              ? servicekleberProperty.tib.name
              : servicekleberProperty.tib.name +
                " " +
                servicekleberProperty.data.extRef
          }}
        </h3>
        <p>
          {{ servicekleberProperty.address.tib.name }}
          {{ servicekleberProperty.data && servicekleberProperty.data.tenant }},
          {{ servicekleberProperty.address.data.address }},
          {{ servicekleberProperty.address.data.city }}<br /><br />
        </p>
        <form class="mt-3">
          <div class="form-group">
            <label for="exampleFormControlInput1">Email*</label>
            <input
              type="email"
              class="form-control"
              id="exampleFormControlInput1"
              placeholder="name@example.com"
              v-model="journalEntry.email"
            />
          </div>
          <div class="form-group">
            <label for="firstName">Vorname</label>
            <input
              type="text"
              class="form-control"
              id="firstName"
              placeholder="First Name"
              v-model="journalEntry.firstName"
            />
          </div>
          <div class="form-group">
            <label for="lastName">Name</label>
            <input
              type="text"
              class="form-control"
              id="lastName"
              placeholder="Name"
              v-model="journalEntry.lastName"
            />
          </div>
          <div class="form-group">
            <label for="phoneNr">Telefonnummer</label>
            <input
              type="text"
              class="form-control"
              id="phoneNr"
              placeholder="+41 61 555 5555"
              v-model="journalEntry.phoneNr"
            />
          </div>
          <div class="form-group alert alert-danger" role="alert">
            <p class="small">Falls Sie für Ihre Bezahlung kein Produkt erhalten haben, dann geben Sie bitte unbedingt ihre Telefonnummer an. Andernfalls können wir aus organisatorischen Gründen nicht sicherstellen, dass wir Ihr Guthaben zurückvergüten können!</p>
          </div>
          <div class="form-group">
            <label for="text">Nachricht*</label>
            <textarea
              class="form-control"
              id="text"
              rows="4"
              v-model="journalEntry.text"
            ></textarea>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <div class="row mx-auto">
          <div class="col-xs-6 mx-1">
            <button
              v-bind:disabled="isSaveDisabled"
              @click="save()"
              type="button"
              class="btn btn-outline-dark btn-block"
            >
              <i class="far fa-save"></i>&nbsp;Abschicken
            </button>
          </div>
          <div class="col-xs-6 mx-1">
            <button
              @click="cancel()"
              type="button"
              class="btn btn-outline-dark btn-block"
              data-dismiss="modal"
            >
              <i class="far fa-times-circle"></i>&nbsp;Abbrechen
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { emptyJournalEntry } from "@/common/constants";
// import { translation } from "@/common/constants";
import { isEmptyString, validEmail } from "@/common/utils";
export default {
  name: "faultReport",
  data: function() {
    return {
      journalEntry: emptyJournalEntry
    };
  },
  mounted() {
    this.prepareJournalEntry();
  },
  computed: {
    isSaveDisabled() {
      return (
        !validEmail(this.journalEntry.email) ||
        isEmptyString(this.journalEntry.text)
      );
    }
  },
  methods: {
    prepareJournalEntry() {
      this.journalEntry = JSON.parse(JSON.stringify(emptyJournalEntry));
      this.journalEntry.journalType = "faultReport";
    },
    save() {
      this.journalEntry.subject = this.faultReportTitleProperty + " " + this.servicekleberProperty.tib.name;
      this.journalEntry.text = this.journalEntry.text +
        "\nReferenz: " + this.servicekleberProperty.data.extRef +
        "\nAdresse: " + this.servicekleberProperty.address.tib.name + " " + this.servicekleberProperty.address.data.address + " " + this.servicekleberProperty.address.data.city +
        "\nStockwerk: " + this.servicekleberProperty.data.floor +
        "\nStandort: " + this.servicekleberProperty.data.deviceLocation +
        "\nBesitzer: " + this.servicekleberProperty.data.tenant +
        "\nHersteller: " + this.servicekleberProperty.data.manufacturer +
        "\nGerätename: " + this.servicekleberProperty.data.deviceName +
        "\nGerätetyp: " + this.servicekleberProperty.data.deviceType +
        "\nSeriennummer: " + this.servicekleberProperty.data.serialNumber +
        "\nTypennummer: " + this.servicekleberProperty.data.deviceNumber;
      ;

      this.$emit("savejournalentry", this.journalEntry);
    },
    cancel() {
      this.$emit("cancel");
    }
  },
  props: {
    servicekleberProperty: Object,
    faultReportTitleProperty: String
  }
};
</script>
